import { handleDelete } from '@/domain/mitarbeiter/features/rotationsplan/features/DeleteRotationsplan/handleDelete';
import { useDeleteRotationsplan } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteRotationsplan/useDeleteRotationsplan';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Body,
  Button,
  DrawerDescription,
  DrawerFooter,
  DrawerTitle,
} from '@e2n/ui/v2';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function DeleteRotationsplanMobile({
  handleClose,
  rotationsplanId,
}: {
  handleClose: () => void;
  rotationsplanId: string;
}) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const [deleteRotationsplan] = useDeleteRotationsplan(standortIds);
  const navigate = useNavigate();

  async function handleConfirm() {
    handleDelete({
      deleteRotationsplan,
      navigate,
      rotationsplanId,
      t,
      setIsSubmitting,
    });
  }

  return (
    <>
      <DrawerTitle>
        {t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogTitle',
        )}
      </DrawerTitle>
      <div className="flex flex-col gap-2">
        <DrawerDescription>
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dialogText',
          )}
        </DrawerDescription>
        <Body className="text-center text-error-red-200">
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.infoStandortwechsel',
          )}
        </Body>
      </div>
      <DrawerFooter>
        <Button
          disabled={isSubmitting}
          variant="primary-pill"
          onClick={handleConfirm}>
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.confirm',
          )}
        </Button>
        <Button variant="secondary-blue" onClick={handleClose}>
          {t(
            'domain.mitarbeiter.rotationsplan.rotationsplaene.deleteRotationsplan.dismiss',
          )}
        </Button>
      </DrawerFooter>
    </>
  );
}
